'use strict';
import React from 'react';
import {buildFormHOC} from '../../../components/forms/Form';
import {INPUT_TYPES} from '../../../components/forms/FormField';
import {MilestoneFormView} from './MilestoneFormView';


export const MilestoneFormComponent = buildFormHOC(MilestoneFormView, {
  fields: [{
    property: 'name',
    type: INPUT_TYPES.text,
    constraints: {nullable: false},
    canEdit: true,
    useError: true,
  }, {
    property: 'description',
    type: INPUT_TYPES.text_long,
    constraints: {nullable: true},
    canEdit: true,
    useError: true,
  }],
});



// WEBPACK FOOTER //
// ./src/js/projects/components/MilestoneForm/MilestoneFormComponent.js